import SingleJob from './SingleJob'
export default SingleJob